import React, { createContext, useCallback, useState } from 'react';

export const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [searchRadius, setSearchRadius] = useState(10); // km

  const updateStores = useCallback((newStores) => {
    setStores(newStores);
  }, []);

  const selectStore = useCallback((store) => {
    setSelectedStore(store);
  }, []);

  const value = {
    // State
    stores,
    loading,
    error,
    selectedStore,
    userLocation,
    searchRadius,
    
    // Actions
    setStores: updateStores,
    setLoading,
    setError,
    selectStore,
    setUserLocation,
    setSearchRadius,
  };

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
};
